import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import Spinner from '../Global/Spinner';
import Table from '../../layout/admin/Table';
export default function UserList() {
	const [users, setUsers] = useState([]);
	const [loading, setLoading] = useState(false);
	const getUsers = async () => {
		try {
			setLoading(true);
			console.log('inside get clients');
			const { data } = await client.get('/user/all');
			console.log({ data });
			if (data) setUsers(data.users);
			setLoading(false);
		} catch (error) {
			setLoading(false);
			return console.error('no users');
		}
	};
	useEffect(() => {
		getUsers();
	}, []);
	if (loading) return <Spinner />;

	return (
		<div className=''>
			<Table
				data={users}
				title='Users'
				description='This is a list of all users.'
			/>
		</div>
	);
}
